import * as Models from "../../../Models";
import * as UserManagementApiClient from './UserManagementApiClientService';
import * as Services from "../../../Services";
import * as UserManagement from "../";
import * as Common from "../../../Common/modules";
import * as toastr from "toastr";
import * as _ from "lodash";


    export interface IUserSaveService {
        saveUser: (user: Models.UserModel.IUserModel) => ng.IPromise<void>;
        lockUser(userId: string): ng.IPromise<void>;
        unlockUser(userId: string): ng.IPromise<void>;
        disableUser: (userId: string) => ng.IPromise<void>;
        enableUser: (userId: string) => ng.IPromise<void>;
    }

    export class UserSaveService implements IUserSaveService {
        public static $inject = ['UserManagementApiClientService'];

        constructor(private userManagementApiClientService: UserManagementApiClient.IUserManagementApiClientService) {
        }

        public saveUser = (user: Models.UserModel.IUserModel) => {
            return this.userManagementApiClientService.saveUser(user);
        }

        public lockUser = (userId: string) => {
            return this.userManagementApiClientService.lockUser(userId);
        }

        public unlockUser = (userId: string) => {
            return this.userManagementApiClientService.unlockUser(userId);
        }

        public enableUser = (userId: string) => {
            return this.userManagementApiClientService.enableUser(userId);
        }

        public disableUser = (userId: string) => {
            return this.userManagementApiClientService.disableUser(userId);
        }
    }